<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue';
import { useCompanyStore } from '@Stores/company.store';
import { useLocationStore } from '@Stores/location.store';
import useCompanyImageBaseUrl from '@Use/useCompanyImageBaseUrl';
import useDashboardContext from '@Use/useDashboardContext';
import { DetailsLayout, FlowLayout, IllustrationDocumentSignature } from '@Shared';
import { verifyUserApi } from '@Api/activitySession.api';
import EsignatureSuccessContent from '@Components/EsignatureSuccessContent.vue';

const companyImageBaseUrl = useCompanyImageBaseUrl();
const companyStore = useCompanyStore();
const locationStore = useLocationStore();
const { isDashboardContext, isLoadingContext } = useDashboardContext();

const isLoading = ref(true);
const isPageLoading = computed(() => isLoading.value || isLoadingContext.value);

onMounted(async () => {
    isLoading.value = true;
    try {
        await verifyUserApi();
    } finally {
        isLoading.value = false;
    }
});
</script>

<template>
    <app-page-loader v-if="isPageLoading" />

    <details-layout
        v-else-if="isDashboardContext"
        title="Your documents"
        illustration-align="bottom"
        :company="companyStore.company"
        :brand="companyStore.brand"
        :location="locationStore.location"
        :company-image-base-url="companyImageBaseUrl">
        <template #illustration>
            <illustration-document-signature />
        </template>

        <esignature-success-content :show-title="false" />
    </details-layout>

    <flow-layout
        v-else
        is-white-label
        :company="companyStore.company"
        :brand="companyStore.brand"
        :location="locationStore.location"
        :company-image-base-url="companyImageBaseUrl">
        <esignature-success-content />
    </flow-layout>
</template>
